import type { AdminTenantCredential } from '../../../services/api';

/** Anzeigestatus von Tenant-Zugangsdaten in der Liste. */
export type CredentialStatus = 'active' | 'revoked' | 'expired';

/**
 * Leitet den Anzeigestatus ab — Widerruf schlägt Ablauf, weil er die bewusste
 * Admin-Aktion ist.
 * @param credential Zugangsdaten aus der Liste.
 * @param now Referenzzeitpunkt (injizierbar für Tests).
 * @returns 'revoked', 'expired' oder 'active'.
 */
export function credentialStatus(credential: AdminTenantCredential, now: Date = new Date()): CredentialStatus {
  if (!credential.isActive) return 'revoked';
  if (credential.expiresAt && new Date(credential.expiresAt).getTime() <= now.getTime()) return 'expired';
  return 'active';
}

/**
 * Wandelt den Wert eines `<input type="date">` in einen ISO-Zeitstempel am
 * Ende des gewählten Tages (lokale Zeit) — Zugangsdaten gelten den ganzen Tag.
 * @param dateInput `YYYY-MM-DD` oder leerer String.
 * @returns ISO-String; undefined bei leerer oder ungültiger Eingabe.
 */
export function expiryDateToIso(dateInput: string): string | undefined {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateInput.trim());
  if (!match) return undefined;
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 23, 59, 59, 999);
  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
}

/**
 * Baut den JSON-Body für `POST /v1/auth/token` — zum Kopieren für den Partner.
 * @param clientId Client-ID der Zugangsdaten.
 * @param clientSecret Einmalig angezeigtes Secret.
 * @returns Formatierter JSON-Body.
 */
export function buildTokenRequestBody(clientId: string, clientSecret: string): string {
  return JSON.stringify({ grantType: 'client_credentials', clientId, clientSecret }, null, 2);
}
